export default "__VITE_ASSET__366be1dc__"